import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import GoodFitResult from './GoodFitResult'

// Wraps GoodFitResult with its recaptcha provider so react-google-recaptcha-v3
// stays out of the main chunk (the provider previously lived inline in routes.tsx).
const GoodFitResultPage = () => {
  return (
    <GoogleReCaptchaProvider
      useEnterprise
      reCaptchaKey={window.__DivvyEnvironment.GOOGLE_RECAPTCHA_SITE_KEY ?? ''}
      scriptProps={{ appendTo: 'body', defer: true }}
    >
      <GoodFitResult />
    </GoogleReCaptchaProvider>
  )
}

export default GoodFitResultPage
